import {
    ITopicHeaders,
    MessageBroker,
    PersonalLimitsPopupType,
    PostLoginActionNameEnum,
} from '@sparkware/uc-sdk-core';
import { UiChannel } from '@sparkware/uc-sdk-core/lib/message-broker/channels/ui/ui.channel';
import PersonalLimitsApi from '../../../../APIs/PersonalLimitsApi';
import DialogType from '../../ui/enums/DialogType';
import { IPostLoginActionsState } from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';

const MB_HEADER: ITopicHeaders = { publisher: 'GetPersonalLimitsPostLoginAction' };

export class GetPersonalLimitsPostLoginAction extends PostLoginActionBase {
    private _uiChannel: UiChannel;

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.GetPersonalLimits, 'GetPersonalLimitsPostLoginAction', state);
        this._uiChannel = MessageBroker.getInstance().ui;
    }

    protected doAction = async (): Promise<void> => {
        const { response, errorResponse } = await PersonalLimitsApi.GetPersonalLimits();

        if (response) {
            if (response.DisplayableLimits && response.DisplayableLimits.length > 0) {
                this._uiChannel.topics.DialogShow.publish(MB_HEADER, {
                    dialogType: DialogType.PersonalLimits,
                    options: {
                        type: PersonalLimitsPopupType.Toast,
                        displayableLimits: response.DisplayableLimits,
                    },
                });
            }
        }

        if (errorResponse) {
            this._logger.error(`_internalExecute ${this.actionName}, error:`, errorResponse);
        }

        this.completeAction();
    };
}
